import React from 'react'
import PropTypes from 'prop-types'
import { ContextHeadline, HeadlineLevel } from '@aok/text-elements'
import { StructuredDataRecipe } from '@aok/structured-data'

import MacroContainer from '../../_layout/Macro/MacroContainer'
import { Clock, Calories } from '@aok/icon-functional'

import DietIcon from './DietIcon'
import { DietType } from './dietTypes'

const M002 = ({ meta, steps, structuredDataInformation }) => {
  const structuredSteps = steps.map((step) => ({
    text: step,
  }))

  return (
    <MacroContainer dataTrackingName="M002">
      {structuredDataInformation && (
        <StructuredDataRecipe
          image={structuredDataInformation.image}
          name={structuredDataInformation.headline}
          datePublished={structuredDataInformation.datePublished}
          keywords={
            structuredDataInformation?.keywords?.length > 0
              ? structuredDataInformation.keywords.reduce((previous, current) => `${previous}, ${current}`)
              : undefined
          }
          calories={meta.energy.toString()}
          totalTime={`PT${meta.duration}M`}
          steps={structuredSteps}
        />
      )}

      {/* Headline */}
      <HeadlineLevel>
        <ContextHeadline
          text="Zubereitung"
          className="
            text-24 leading-32 font-buenos-aires font-semibold text-005e3f
            1280:leading-36
          "
        />
      </HeadlineLevel>

      {/* Meta information */}
      {meta && (
        <div
          className="
                mt-16 flex gap-x-16 text-6d767c
              "
        >
          {meta.duration && (
            <p className="flex gap-x-8" aria-label={`dauert ${meta.duration} Minuten`}>
              <Clock className="w-16 h-16 fill-current" />
              <span aria-hidden>{`${meta.duration} Min.`}</span>
            </p>
          )}
          {meta.energy && (
            <p className="flex gap-x-8" aria-label={`hat ${meta.energy} Kilokalorien`}>
              <Calories className="w-16 h-16 fill-current" />
              <span aria-hidden>{`${meta.energy} kcal`}</span>
            </p>
          )}
          {meta.diet && (
            <p className="flex gap-x-8" aria-label={`ist ${meta.diet}`}>
              <DietIcon diet={meta.diet} className="w-16 h-16 fill-current" />
              <span aria-hidden>{meta.diet}</span>
            </p>
          )}
        </div>
      )}

      {/* Steps */}
      <ol className="mt-40 600:mt-44">
        {steps.map((step, index) => (
          <li
            key={index}
            className={`
                relative flex gap-x-16 600:ml-16 720:gap-x-24
                ${index < steps.length - 1 ? 'pb-40 600:pb-48' : ''}
              `}
          >
            {/* Step number indicator */}
            <span
              aria-hidden
              className="
                  flex-shrink-0 rounded-full border-2 border-afb6bc w-40 h-40 inline-flex items-center justify-center text-004730 text-16 leading-24 font-semibold
                "
            >
              <span className="relative top-1">{index + 1}</span>
            </span>

            {/* Step description */}
            <p className="text-16 leading-24 1280:relative 1280:top-10">{step}</p>

            {/* Dots between steps */}
            {index < steps.length - 1 && (
              <span className="absolute mt-20 top-1/2 -translate-y-1/2 -translate-x-1/2 left-20  h-20 w-1 border-c7ccd1 border-l-4 border-dotted" />
            )}
          </li>
        ))}
      </ol>
    </MacroContainer>
  )
}

M002.propTypes = {
  meta: PropTypes.shape({
    duration: PropTypes.number,
    energy: PropTypes.number,
    diet: PropTypes.oneOf(Object.values(DietType)),
  }),
  steps: PropTypes.arrayOf(PropTypes.string),
  structuredDataInformation: PropTypes.shape({
    image: PropTypes.string,
    headline: PropTypes.string,
    datePublished: PropTypes.string,
    dateModified: PropTypes.string,
    keywords: PropTypes.arrayOf(PropTypes.string),
  }),
}

M002.defaultProps = {
  steps: [],
}

export default M002
